import { differenceInDays, differenceInMinutes as ApiDifferenceInMinutes, differenceInMonths, format, subDays, subMonths, subYears } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export function toMonthYearString(date: Date){
    const d = new Date(date)
    const _date = new Date(d.getUTCFullYear(), d.getUTCMonth(), 15)
    const result = format(_date, 'MMMM/yyyy', { locale: ptBR })
    return result
}

export function toMonthYearSmallString(date: Date){
    const d = new Date(date)
    const _date = new Date(d.getUTCFullYear(), d.getUTCMonth(), 15)
    const result = format(_date, 'MMM/yyyy', { locale: ptBR })
    return result
}

export function toHourMinuteString(date?: Date){
    if(!date) return '-'
    return format(date, 'HH:mm', { locale: ptBR })
}

export function toDateMonthYearString(date?: Date){
    if(!date) return '-'
    return format(date, 'dd/MM/yyyy', { locale: ptBR })
}

export function toDateMonthYearHourMinuteString(date?: Date){
    if(!date) return '-'
    return format(date, 'dd/MM/yyyy HH:mm', { locale: ptBR })
}

export function toDateHourMinuteString(date?: Date){
    if(!date) return '-'
    return format(date, 'yyyy/MM/dd HH:mm', { locale: ptBR })
}

export function toDateHourMinuteSecondString(date?: Date){
    if(!date) return '-'
    return format(date, 'yyyy/MM/dd HH:mm:ss', { locale: ptBR })
}

export function getOneYearBefore(date: Date): Date {
    return subYears(date, 1)
}

export function getOneMonthBefore(date: Date): Date {
    return subMonths(date, 1)
}

export function getMonthsBefore(date: Date, sub: number): Date {
    return subMonths(date, sub)
}

export function getDaysBefore(date: Date, sub: number): Date {
    return subDays(date, sub)
}

export function getHoursBefore(date: Date, hours: number): Date {
    const d = new Date(date)
    d.setHours(d.getHours() - hours)
    return d
}

export function getMinutesAfter(date: Date, minutes: number): Date {
    const d = new Date(date)
    d.setMinutes(d.getMinutes() + minutes)
    return d
}

export function monthsDifference(date1: Date, date2: Date){
    return differenceInMonths(date1, date2)
}

export function difference(date1: Date, date2: Date){
    return differenceInDays(date1, date2)
}

export function differenceInMinutes(date1: Date, date2: Date){
    return ApiDifferenceInMinutes(date1, date2)
}

export function sortByDate(a: Date, b: Date, ascending: boolean) {
    const comparison = a.getTime() - b.getTime();
    return ascending ? comparison : -comparison;
}

export function isInSameMonth(date1: Date, date2: Date){
    return date1.getUTCFullYear() === date2.getUTCFullYear() && date1.getUTCMonth() === date2.getUTCMonth()
}

export function isInSameYear(date1: Date, date2: Date){
    return date1.getUTCFullYear() === date2.getUTCFullYear()
}

export function startOfFifteenMinutes(date: Date): Date {
    const minutes = date.getMinutes();
    const startMinutes = Math.floor(minutes / 15) * 15;

    const startDate = new Date(date);
    startDate.setMinutes(startMinutes, 0, 0);

    return startDate;
}

export function endOfFifteenMinutes(date: Date): Date {
    const startDate = startOfFifteenMinutes(date);
    const endDate = new Date(startDate);
    endDate.setMinutes(startDate.getMinutes() + 15);
    return endDate;
}

export function getStartAndEndOfFifteenMinutes(date: Date): { startDate: Date; endDate: Date } {
    const startDate = startOfFifteenMinutes(date);
    const endDate = endOfFifteenMinutes(date);
    return { startDate, endDate };
}